"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("react"),o=t=>t&&t.__esModule?t:{default:t},n=o(e),a=n.default.createContext({});exports.AnalyticsContext=a;
